import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { GenerateQrCodeInPng200Response } from '../../api';
import qrCodeApi from './qr-code-api';

interface GenerateQrCodeVariables {
  url: string;
  onSuccess: (response: GenerateQrCodeInPng200Response) => void;
}

const useGenerateQrCodePng = (): UseMutationResult<
  GenerateQrCodeInPng200Response,
  unknown,
  GenerateQrCodeVariables,
  unknown
> => {
  return useMutation({
    mutationFn: (variables: GenerateQrCodeVariables) =>
      qrCodeApi.generateQrCodeInPng(variables.url, {
        responseType: 'arraybuffer',
      }),
    onSuccess: (response, variables) => {
      variables.onSuccess(response);
    },
  });
};

export default useGenerateQrCodePng;
